import { Controller } from "@hotwired/stimulus"

// "Its page sells N options" (release_watch/links/_page_options): Each on
// its own (a line per page option) or As one link. Only the fields of the
// one shown are sent; none at all while the box is in a hidden part of the
// page (an inbox card's merge box for a figure not ticked). A page option's
// "Another figure…" is each line's rw-figure-pick. A new figure's line
// names its option, with a select beside the name to skip the page option
// or send it to another figure: that select is sent in the name's place
// once it's moved off "on this figure".
export default class extends Controller {
  static targets = ["mode"]

  connect() {
    this.element.querySelectorAll("select[data-field]").forEach(select => this.place(select))
    this.sync()
  }

  pick(event) {
    const mode = event.currentTarget.dataset.v
    this.element.dataset.split = mode
    this.modeTarget.value = mode
    this.element.querySelectorAll(".po-seg button").forEach(button => {
      button.classList.toggle("on", button.dataset.v === mode)
      button.setAttribute("aria-pressed", button.dataset.v === mode)
    })
    this.sync()
  }

  sync() {
    const mode = this.element.dataset.split
    const hidden = !!this.element.closest("[hidden]")
    this.modeTarget.disabled = hidden
    this.element.querySelectorAll("[data-when]").forEach(field => { field.disabled = hidden || field.dataset.when !== mode })
  }

  // A line's select changed (rw-figure-pick:change).
  placed(event) { this.place(event.target) }

  // A new figure's line: the name sent while it's on this figure, the select otherwise.
  place(select) {
    const field = select.dataset.field
    if (!field) return
    const name = select.closest(".po-new").querySelector("input")
    const away = select.value !== ""
    name.hidden = away
    if (away) { name.removeAttribute("name"); select.name = field } else { select.removeAttribute("name"); name.name = field }
  }
}
